module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs-slim"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(_vm.loadsScheduledCounts.loads_today))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: [_vm.scheduledDayIncreaseIsNegative ? 'text-danger' : 'text-info']
  }, [_vm._v(_vm._s(_vm.scheduledDayIncrease) + "%\n                "), (_vm.loadsScheduledCounts.day_increase >= 0) ? _c('i', {
    staticClass: "fa fa-level-up"
  }) : _c('i', {
    staticClass: "fa fa-level-down"
  })]), _vm._v(" "), _c('small', [_vm._v("Today")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(_vm.loadsScheduledCounts.loads_this_month))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: [_vm.scheduledMonthIncreaseIsNegative ? 'text-danger' : 'text-info']
  }, [_vm._v("\n                " + _vm._s(_vm.scheduledMonthIncrease) + "%\n                "), (_vm.loadsScheduledCounts.month_increase >= 0) ? _c('i', {
    staticClass: "fa fa-level-up"
  }) : _c('i', {
    staticClass: "fa fa-level-down"
  })]), _vm._v(" "), _c('small', [_vm._v("This Month")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs-slim"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(_vm.commissionTodayFormatted))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: [_vm.commissionDayIncreaseIsNegative ? 'text-danger' : 'text-info']
  }, [_vm._v(_vm._s(_vm.commissionDayIncrease) + "%\n                "), (_vm.commissionData.day_increase >= 0) ? _c('i', {
    staticClass: "fa fa-level-up"
  }) : _c('i', {
    staticClass: "fa fa-level-down"
  })]), _vm._v(" "), _c('small', [_vm._v("Today")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(_vm.commissionMonthFormatted))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: [_vm.commissionMonthIncreaseIsNegative ? 'text-danger' : 'text-info']
  }, [_vm._v(_vm._s(_vm.commissionMonthIncrease) + "%\n                "), (_vm.commissionData.month_increase >= 0) ? _c('i', {
    staticClass: "fa fa-level-up"
  }) : _c('i', {
    staticClass: "fa fa-level-down"
  })]), _vm._v(" "), _c('small', [_vm._v("This Month")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ibox-content no-padding-top"
  }, [_c('div', [_c('loads-per-day-graph')], 1)])])]), _vm._v(" "), (_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ibox-content no-padding-top"
  }, [_c('div', [_c('commission-per-day-graph')], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "ibox-content no-padding-top"
  }, [_c('div', [_c('user-growth-graph')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Loads Scheduled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Commission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Loads Per Day")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Commission Per Day")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("User Growth Per Month")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-f2d779fc"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Graphs.vue
// module id = 1088
// module chunks = 0